import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { HELP_CLINIC_PROFILE } from '../../../shared/constants/help-buttons';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { SettingEditModalComponent } from '../../../shared/admin-setting/edit-modal/edit-modal.component';

@Component({
    selector: 'self-reports-modal-component',
    templateUrl: './self-reports-modal.component.html',
    styleUrls: ['./self-reports-modal.component.scss'],
})
export class SelfReportsModalComponent extends SettingEditModalComponent implements OnChanges {
    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() form: FormGroup;
    @Input() formSubmitted: boolean;
    @Input() languages: Object[];
    @Input() itemLanguage: string;
    @Input() selfReports: Object[];
    @Input() domains: Object[];
    @Input() filteredDomains: Object[];
    @Input() standards: Object[];
    @Input() authService: AuthService;
    @Input() token: string;
    @Input() helpRawData = '';

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    orderedDomains: any;

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) {
        super(popoverService, translate);
    }

    removeDomain(domain){
        const data = this.form.controls['domains'].value;
        _.remove(data, function(item){
            return item == domain['id'];
        });
        return this.form.controls['domains'].setValue(data);
    }
}
